<template>
  <DefaultLayout>
    <template v-slot:title>
      Projects > New Project
    </template>
    <progress-bar :step="step" />
    <search class="mb-10" placeholder="Search repositories"/>
    <select-repo v-if="step === 1" @select="selectRepo"/>
    <project-type v-if="step === 2" @next="step = 3"/>
    <project-settings v-if="step === 3"/>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/components/layouts/DefaultLayout.vue'
import ProgressBar from '@/components/shared/ProgressBar.vue'
import Search from '@/components/shared/Search.vue'
import SelectRepo from '@/components/add-project/SelectRepo.vue'
import ProjectType from '@/components/add-project/ProjectType.vue'
import ProjectSettings from '@/components/add-project/ProjectSettings.vue'

export default {
  name: 'AddProject',
  components: {
    DefaultLayout,
    ProgressBar,
    Search,
    SelectRepo,
    ProjectType,
    ProjectSettings
  },
  computed: {
    rebuildCommand () {
      switch (this.type) {
        case 'gatsby':
          return 'curl -X POST http://$JAM_PREVIEW_HOST:$JAM_PREVIEW_PORT/__refresh'
        default:
          return ''
      }
    }
  },
  data: function () {
    return {
      step: 1,
      selectedRepo: '',
      name: '',
      type: '',
      branch: '',
      serveCommand: '',
      envVar: '',
      password: ''
    }
  },
  methods: {
    async addProject () {
      debugger
      this.$store.dispatch('addProject', { project: {
        'name': this.name,
        'type': this.type,
        'branch': this.branch,
        'repository': this.selectedRepo,
        'serve_command': this.serveCommand,
        'rebuild_command': this.rebuildCommand,
        'env': this.envVar,
        'password': this.password
      } })
    },
    selectRepo (repo) {
      this.selectedRepo = repo
      this.step = 2
    }
  }

}

</script>

<style scoped lang="scss">

</style>
